import React from 'react';
import { siteContent } from '../../data/content';
import './Missions.css';

const Missions = () => {
  const handleCTAClick = (href) => {
    if (href.startsWith('#')) {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <section id="missions" className="missions section">
      <div className="container">
        <div className="missions__header">
          <h2 className="missions__title">{siteContent.missions.title}</h2>
        </div>
        
        <div className="missions__grid">
          {siteContent.missions.list.map((mission, index) => (
            <div key={index} className="missions__card">
              <div className="missions__card-number">
                {String(index + 1).padStart(2, '0')}
              </div>
              <div className="missions__card-content">
                <h3 className="missions__card-title">{mission.title}</h3>
                <p className="missions__card-description">{mission.description}</p>
              </div>
              <div className="missions__card-icon">
                <div className="missions__card-icon-inner"></div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="missions__cta">
          <a
            href={siteContent.missions.cta.href}
            className="btn btn-primary btn-lg"
            onClick={(e) => {
              e.preventDefault();
              handleCTAClick(siteContent.missions.cta.href);
            }}
          >
            {siteContent.missions.cta.text}
          </a>
        </div>
      </div>
    </section>
  );
};

export default Missions;

